import React from 'react';
import MasterCrud from './MasterCrud';

export default function Drivers() {
  return (
    <MasterCrud
      title="Drivers"
      endpoint="/api/master/drivers"
      columns={[
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'defaultSharePct', label: 'Default Share %' },
        { key: 'updatedAt', label: 'Last updated' },
      ]}
      formFields={[
        { key: 'name', label: 'Name', required: true },
        { key: 'email', label: 'Email', type: 'email' },
        { key: 'defaultSharePct', label: 'Default Share %', type: 'number', helperText: '0–100' },
      ]}
    />
  );
}
